import React from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
// import "./index.scss";

import ContentBox from "../../../../../../ui/ContentBox";

import { formatDate } from "../../../../../../../utils/util";


const DomainInformation = ({SimilarDomainData, currentPageType}) => {
    return (
        <>
            {currentPageType === "similarDomain" && <Row>
                <Col lg={4}>
                    <div className={`hacker-score-container similar-domain p-3 rounded my-3 w-100 ${SimilarDomainData?.additional_info?.similarity_score?.logo <= 50 ? "green" : "red"}`}>
                        <p className="hacker-score">{SimilarDomainData?.additional_info?.similarity_score?.logo}%</p>
                        <p className="hacker-text">Logo Similarity</p>
                    </div>
                </Col>
                <Col lg={4}>
                    <div className={`hacker-score-container similar-domain p-3 rounded my-3 w-100 ${SimilarDomainData?.additional_info?.similarity_score?.brand_keyword <= 50 ? "green" : "red"}`}>
                        <p className="hacker-score">{SimilarDomainData?.additional_info?.similarity_score?.brand_keyword}%</p>
                        <p className="hacker-text">Brand Keyword Similarity</p>
                    </div>
                </Col>
                <Col lg={4}>
                    <div className={`hacker-score-container similar-domain p-3 rounded my-3 w-100 ${SimilarDomainData?.additional_info?.similarity_score?.domain <= 50 ? "green" : "red"}`}>
                        <p className="hacker-score">{SimilarDomainData?.additional_info?.similarity_score?.domain}%</p>
                        <p className="hacker-text">Domain Similarity</p>
                    </div>
                </Col>
            </Row>}
            <Row className="mb-4">
                <Col lg={6}>
                    <ContentBox label={currentPageType === "similarDomain" ? "Similar Domain" : "Associated Domain"} value={currentPageType === "similarDomain" ? SimilarDomainData?.similar_domain : SimilarDomainData?.associated_domain}/>
                </Col>
                <Col lg={6}>
                    <ContentBox label={"Registrant"} value={SimilarDomainData?.registrant_name}/>
                </Col>
            </Row>
            <Row className="mb-4">
                <Col lg={6}>
                    <ContentBox label={"Registrar"} value={SimilarDomainData?.registrar_name}/>
                </Col>
                <Col lg={6}>
                    <ContentBox label={"Email"} value={SimilarDomainData?.email_address}/>
                </Col>
            </Row>
            <Row className="mb-4">
                <Col lg={6}>
                    <ContentBox label={"Created On"} value={formatDate(SimilarDomainData?.create_date, "date")}/>
                </Col>
                <Col lg={6}>
                    <ContentBox label={"Expiry Date"} value={formatDate(SimilarDomainData?.expiry_date, "date")}/>
                </Col>
            </Row>
        </>
    )
}

export default DomainInformation;